import React from "react";

const SvgMenu = props => <svg viewBox="0 0 20 20" {...props}><path fill="currentColor" fillRule="evenodd" d="M19 11H1a1 1 0 1 1 0-2h18a1 1 0 1 1 0 2zm0-7H1a1 1 0 1 1 0-2h18a1 1 0 1 1 0 2zm0 14H1a1 1 0 1 1 0-2h18a1 1 0 1 1 0 2z" /></svg>;

export default SvgMenu;